import instance from "../axios";

const getTables = (idEvent: number, offset: number) => {
  return instance.get(
    `/Admin/Tables/GetEventTables?IdEvent=${idEvent}&Offset=${offset}`
  );
};

const insertTable = (table: any) => {
  return instance.post(`/Admin/Tables/InsertEventTable`, table);
};

const updateTable = (table: any) => {
  return instance.put(`/Admin/Tables/UpdateEventTable`, table);
};

const deleteTable = (id: number) => {
  return instance.delete(`/Admin/Tables/DeleteEventTable`, {
    data: { IdEventTable: id },
  });
};

export const TableService = {
  getTables,
  insertTable,
  updateTable,
  deleteTable,
};
